import { takeLatest, call, put } from "redux-saga/effects";

import advertisingService from "../../services/advertisingService";
import { alertTypes } from "../constants";
import {
  welcomeVideoAction,
  enableAction,
  disableAction,
  resyncAction,
} from "../reducers/videoWelcomeReducer";
import { sagaPromise } from "../../helpers/saga-promise-helpers";
import { VIDEO_WELCOME_MESSAGES } from "../../config/messages";

function* searchWorkerWelcome(action) {
  try {
    const { data, error } = yield call(
      advertisingService.searchWelcome,
      action.payload?.params
    );
    if (error) {
      yield put(welcomeVideoAction.fetch.error(error));
    } else {
      yield put(welcomeVideoAction.fetch.success({ ...action, data }));
    }
  } catch (err) {
    yield put(welcomeVideoAction.fetch.error(err));
  }
}

function* setWelcomeVideoWorker(action) {
  const { data, error } = yield call(
    advertisingService.setWelcome,
    action.payload.data
  );
  if (error) {
    if (error.headers["x-message-info"]) {
      yield put({
        type: alertTypes.ERROR,
        message: error.headers["x-message-info"],
      });
      throw new Error(error.headers["x-message-info"]);
    }
  } else {
    yield put({
      type: alertTypes.SUCCESS,
      message: VIDEO_WELCOME_MESSAGES.pinSuccess,
    });
    return data;
  }

  return false;
}

function* updateWelcomeVideoWorker(action) {
  const { data, error } = yield call(
    advertisingService.updateWelcome,
    action.payload.data
  );
  if (error) {
    if (error.headers["x-message-info"]) {
      yield put({
        type: alertTypes.ERROR,
        message: error.headers["x-message-info"],
      });
      throw new Error(error.headers["x-message-info"]);
    }
  } else {
    yield put({
      type: alertTypes.SUCCESS,
      message: VIDEO_WELCOME_MESSAGES.updateSuccess,
    });
    return data;
  }

  return false;
}

function* removeWelcomeVideoWorker(action) {
  const { data, error } = yield call(
    advertisingService.removeWelcome,
    action.payload.videoId
  );
  if (error) {
    if (error.headers["x-message-info"]) {
      yield put({
        type: alertTypes.ERROR,
        message: error.headers["x-message-info"],
      });
      throw new Error(error.headers["x-message-info"]);
    }
  } else {
    yield put({
      type: alertTypes.SUCCESS,
      message: VIDEO_WELCOME_MESSAGES.unpinSuccess,
    });
    return data;
  }

  return false;
}

function* enableWelcomeWorker(action) {
  const { data, error } = yield call(
    advertisingService.enableWelcome,
    action.payload.videoId
  );
  if (error) {
    if (error.headers["x-message-info"]) {
      yield put({
        type: alertTypes.ERROR,
        message: error.headers["x-message-info"],
      });
      throw new Error(error.headers["x-message-info"]);
    }
  } else {
    yield put({
      type: alertTypes.SUCCESS,
      message: VIDEO_WELCOME_MESSAGES.enableSuccess,
    });
    return data;
  }

  return false;
}

function* disableWelcomeWorker(action) {
  const { data, error } = yield call(
    advertisingService.disableWelcome,
    action.payload.videoId
  );
  if (error) {
    if (error.headers["x-message-info"]) {
      yield put({
        type: alertTypes.ERROR,
        message: error.headers["x-message-info"],
      });
      throw new Error(error.headers["x-message-info"]);
    }
  } else {
    yield put({
      type: alertTypes.SUCCESS,
      message: VIDEO_WELCOME_MESSAGES.disableSuccess,
    });
    return data;
  }

  return false;
}

function* resyncWelcomeWorker(action) {
  const { error } = yield call(
    advertisingService.resyncWelcome
  );
  if (error) {
    if (error.headers["x-message-info"]) {
      yield put({
        type: alertTypes.ERROR,
        message: error.headers["x-message-info"],
      });
      throw new Error(error.headers["x-message-info"]);
    }
  } else {
    yield put({
      type: alertTypes.SUCCESS,
      message: VIDEO_WELCOME_MESSAGES.resyncSuccess,
    });
  }
  return true;
}

function* reviewSaga() {
  // yield takeLatest(searchVideoAction.start, searchWorker);

  yield takeLatest(
    welcomeVideoAction.fetch.start,
    welcomeVideoAction.fetch.waiterActionForSaga(sagaPromise(searchWorkerWelcome))
  );

  yield takeLatest(
    welcomeVideoAction.create.start,
    welcomeVideoAction.create.waiterActionForSaga(sagaPromise(setWelcomeVideoWorker))
  );

  yield takeLatest(
    welcomeVideoAction.update.start,
    welcomeVideoAction.update.waiterActionForSaga(sagaPromise(updateWelcomeVideoWorker))
  );

  yield takeLatest(
    welcomeVideoAction.delete.start,
    welcomeVideoAction.delete.waiterActionForSaga(sagaPromise(removeWelcomeVideoWorker))
  );

  yield takeLatest(
    enableAction.start,
    enableAction.waiterActionForSaga(sagaPromise(enableWelcomeWorker))
  );

  yield takeLatest(
    disableAction.start,
    disableAction.waiterActionForSaga(sagaPromise(disableWelcomeWorker))
  );

  yield takeLatest(
    resyncAction.start,
    resyncAction.waiterActionForSaga(sagaPromise(resyncWelcomeWorker))
  );

}

export default reviewSaga;
